const user = JSON.parse(localStorage.getItem("user"));
const checkModuleAccess = (moduleID) => {

    const findModule = user?.role?.modules?.findIndex(module => module?.id === moduleID);

    return findModule > -1 ? true : false;
}

const getModule = (moduleID) => {
    const findModule = user?.role?.modules?.find(module => module?.id === moduleID);

    return findModule;
}

const getFeaturesModule = (moduleID) => {
    const module = user?.role?.modules?.find(module => module.id === moduleID);

    return module?.features;
}

export {
    checkModuleAccess,
    getModule,
    getFeaturesModule,
}